import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, take } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PreferencesService } from 'src/app/services/preferences.service';

@Component({
  selector: 'tx-introduction-dialog',
  standalone: true,
  imports: [],
  templateUrl: './introduction-dialog.component.html',
  styleUrl: './introduction-dialog.component.scss'
})
export class IntroductionDialogComponent {

  private dontShowAgain: boolean = false;

  constructor(public activeModal: NgbActiveModal, private preferencesService: PreferencesService, private authService: AuthenticationService) {

  }

  closeDialog() {
    if (this.dontShowAgain) {
      this.preferencesService.setPreference(this.preferencesService.introPopupShowedPreference, this.authService.getInitials(), '1')
      .pipe(take(1))
      .subscribe();
    }

    this.activeModal.dismiss();
  }

  onDontShowAgainChanged(event: any) {
    this.dontShowAgain = event.target.checked;
  }
}
